import { forwardRef } from 'react';
import MUIIconButton, { type IconButtonProps } from '@material-ui/core/IconButton';
import cx from 'classnames';

import { CustomCircularProgress } from 'src/components/CustomCircularProgress';

import { type CustomIconButtonSize, type CustomIconButtonVariant, getFontSize } from './lib';
import { useStyles } from './useStyles';

export interface CustomIconButtonProps extends Omit<IconButtonProps, 'variant' | 'size'> {
  variant?: CustomIconButtonVariant;
  size?: CustomIconButtonSize;
  loading?: boolean;
}

export const CustomIconButton = forwardRef<HTMLButtonElement, CustomIconButtonProps>(
  (
    {
      className,
      classes,
      variant = 'default',
      size = 'medium',
      loading = false,
      disabled = false,
      children,
      ...props
    },
    ref
  ) => {
    const styles = useStyles({ classes, variant, size });

    return (
      <MUIIconButton
        className={cx(styles.root, className, {
          [styles.loading]: loading,
        })}
        classes={{
          label: styles.label,
        }}
        disabled={disabled}
        ref={ref}
        {...props}
      >
        {children}
        {loading && (
          <CustomCircularProgress
            className={styles.spinner}
            size={getFontSize(size)}
            color="inherit"
          />
        )}
      </MUIIconButton>
    );
  }
);

CustomIconButton.displayName = 'CustomIconButton';
